/* Good Tree — global behaviours. Cart drawer + predictive search are added in Phase 2
   (lifted from Dawn). This keeps progressive enhancement: the theme works without JS. */
(function () {
  'use strict';

  // Keep the header "Bag · NN" count in sync after AJAX cart updates dispatch this event.
  document.addEventListener('cart:updated', function (event) {
    var count = event && event.detail && typeof event.detail.item_count === 'number'
      ? event.detail.item_count
      : null;
    if (count === null) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = 'Bag · ' + count;
    });
  });
})();
